import { toast } from "react-toastify";
const CustomToast = {
  success: (content = "") => toast.success(content),
  error: (content = "") => toast.error(content),
  info: (content = "") => toast.info(content),
  warn: (content = "") => toast.warn(content),
};

export default CustomToast;
